import { IssueTaskDoc } from '@gooduncles/gu-app-schema';
import { Button, Select, message, notification } from 'antd';
import { FC } from 'react';

import { updateIssueTask } from 'src/utils/firebase/firebase-short-cut';
import { getIssueTaskLabel } from 'src/utils/issue/issue-util';

import Description from 'src/atomic-components/atoms/Description';
import IssueCardSubTitle from 'src/atomic-components/atoms/IssueCardItem/IssueCardSubTitle';

import styles from './IssueTaskCard.module.scss';

interface IssueTaskConnectorProps {
  issueTaskDoc: IssueTaskDoc;
  issueTaskDocs: IssueTaskDoc[];
  editable?: boolean;
}

const IssueTaskConnector: FC<IssueTaskConnectorProps> = ({ issueTaskDoc, issueTaskDocs, editable = true }) => {
  const options = issueTaskDocs
    .filter((task) => task._id !== issueTaskDoc._id)
    // 현재 task를 linkedTaskId로 참조하는 task들 제외 (순환 참조 방지)
    .filter((task) => task.linkedTaskId !== issueTaskDoc._id)
    .map((task) => ({ label: getIssueTaskLabel(task), value: task._id }));

  const onChangeLinkedTaskId = async (value: string | null) => {
    if (!editable) return;
    try {
      await updateIssueTask(issueTaskDoc._id, { linkedTaskId: value });
      if (value === null) {
        message.success('함께 완료할 태스크를 삭제했습니다.');
      } else {
        message.success('함께 완료할 태스크를 등록했습니다.');
      }
    } catch (error) {
      console.error(error);
      notification.error({ message: '함께 완료할 태스크 변경에 실패했습니다.' });
    }
  };

  return (
    <>
      <div className='flexRow flexAlignCenter flexSpaceBetween' style={{ paddingRight: '8px' }}>
        <IssueCardSubTitle text='함께 완료할 태스크' />
        <Button
          variant='outlined'
          size='small'
          danger
          disabled={!editable || issueTaskDoc.linkedTaskId === null}
          onClick={() => onChangeLinkedTaskId(null)}>
          삭제
        </Button>
      </div>
      <div className={styles.issueTaskItem}>
        <Select
          placeholder='이슈를 선택하세요'
          options={options}
          value={issueTaskDoc.linkedTaskId}
          styles={{
            root: {
              width: '100%',
            },
          }}
          onChange={editable ? onChangeLinkedTaskId : undefined}
          disabled={!editable}
        />
        <Description>*선택한 태스크를 함께 완료 처리합니다.</Description>
      </div>
    </>
  );
};

export default IssueTaskConnector;
